﻿import { get as getProjection } from 'ol/proj';
import { format } from 'ol/coordinate';
import MousePosition from 'ol/control/MousePosition';
export default class MousePositionControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, siblingsBefore) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.siblingsBefore = siblingsBefore;
        this.control = null;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
    }

    init() {
        if (this._isMobileDevice()) return;

        let div = document.createElement('div');
        div.innerHTML = this._getTemplate();

        this.menuContainer.append(div.firstChild);

        this.control = new MousePosition({
            coordinateFormat: (coordinates) => {
                const decimals = this._projectionDecimals(this.mapControl.map.getView().getProjection().getCode());
                return format(coordinates, '{x}&nbsp;&nbsp;&nbsp;{y}', decimals);
            },
            className: 'map-mouse-position',
            target: document.getElementById(this.elementId),
        });

        this.mapControl.map.addControl(this.control);
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }


    _projectionDecimals(projection) {
        if (!getProjection(projection)) return 4;

        const extent = getProjection(projection).extent_;

        for (let i of extent) {
            if (i < -360 || i > 360) return 4
        }

        return 6;
    }

    _getTemplate() {
        return `<div id="` + this.elementId + `" class="map-mouse-position-` + this.siblingsBefore + `">

                </div>`;
    }
}